import { render, staticRenderFns } from "./TracingSpan.vue?vue&type=template&id=65f0295c&scoped=true"
import script from "./TracingSpan.vue?vue&type=script&lang=js"
export * from "./TracingSpan.vue?vue&type=script&lang=js"
import style0 from "./TracingSpan.vue?vue&type=style&index=0&id=65f0295c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0295c",
  null
  
)

export default component.exports